/** وضعیت هر گیرنده در یک پارت ارسال پیامک گروهی (مطابق BulkSmsItemStatus در بک‌اند). */
export enum BulkSmsItemStatus {
    /** سرویس پیامک پذیرفته ولی تحویلش هنوز تایید نشده. */
    Sent = 1,
    Delivered = 2,
    /** ارسال انجام نشد (خطای سرویس، رد شدن شماره، یا کاربر/شماره یافت نشد). */
    Failed = 3,
    /** ارسال شد ولی مخابرات عدم تحویل / فیلتر / لغو گزارش کرد. */
    Undelivered = 4,
}

export interface SendBulkSmsBody {
    /** هر آیتم شماره موبایل یا شناسه‌ی کاربر است. */
    phoneNumbers: string[];
    message: string;
    senderLine: string;
    batchId?: string;
    partNumber?: number;
    totalParts?: number;
}

export interface SendBulkSmsResult {
    partId?: string;
    batchId: string;
    sentCount: number;
    failedCount: number;
    unresolvedUserIds: string[];
}

export interface BulkSmsPart {
    id: string;
    batchId: string;
    partNumber?: number;
    totalParts?: number;
    message: string;
    senderLine: string;
    totalCount: number;
    sentCount: number;
    deliveredCount: number;
    failedCount: number;
    statusCheckedOn?: string;
    createdBy?: string;
    createdOn?: string;
}

export interface BulkSmsPartItem {
    itemId: string;
    receiver: string;
    phoneNumber?: string;
    status: BulkSmsItemStatus;
    messageId?: number;
    providerStatus?: number;
    providerStatusText?: string;
    errorMessage?: string;
    attemptCount: number;
    lastAttemptOn?: string;
    canRetry: boolean;
}

export interface BulkSmsPartDetail {
    partId: string;
    batchId: string;
    partNumber?: number;
    totalParts?: number;
    message: string;
    senderLine: string;
    statusCheckedOn?: string;
    items: BulkSmsPartItem[];
}

export interface RetryBulkSmsItemsResult {
    retriedCount: number;
    sentCount: number;
    failedCount: number;
}

export interface RefreshBulkSmsPartStatusResult {
    checkedCount: number;
    sentCount: number;
    deliveredCount: number;
    failedCount: number;
}
